'use client';
import { MouseEvent } from 'react';
import Button from '@repo/ui/src/components/Button';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { classNames } from '@repo/ui/src/utils/classNames';
import { CTAButtonProps } from '@repo/ui/src/types';

interface Props {
  buttonProps?: CTAButtonProps;
  onClickAddToCart: (e: MouseEvent<HTMLElement>) => void;
  buttonProcessing?: boolean;
  processingText?: string;
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

const OutOfStockButton = ({ buttonProps, className, children }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      {...buttonProps}
      className={classNames(className, buttonProps?.className, 'relative')}
      disabled
    >
      {t('productDetailPageContent.outOfStockText', undefined, {
        default: 'Out of stock',
      })}
      {children}
    </Button>
  );
};

export default OutOfStockButton;
